import {Flex, List, Typography} from "antd";
import {PracticeNote} from "../../models/Practice/PracticeNote";
import {UserOutlined} from "@ant-design/icons";
import {Utils} from "../../services/Utils";

/**
 * Renders note text as HTML, allowing only <strong> and <br> tags.
 * All other HTML is escaped to prevent XSS.
 */
function sanitizeNoteHtml(text: string): string {
    return text
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/&lt;strong&gt;/gi, '<strong>')
        .replace(/&lt;\/strong&gt;/gi, '</strong>')
        .replace(/&lt;br\s*\/?&gt;/gi, '<br/>')
        .replace(/&lt;span&gt;/gi, '<span>')
        .replace(/&lt;\/span&gt;/gi, '</span>');
}

export function NoteList(props: {
    data: Array<PracticeNote>
}) {
    return <div className={"note-container"}>
        <List
            itemLayout="horizontal"
            dataSource={props.data}
            renderItem={(item: PracticeNote, index) => (
                <List.Item>
                    <List.Item.Meta
                        avatar={<UserOutlined/>}
                        title={<Flex justify={"space-between"}>
                            <Typography.Text>{item.operator}</Typography.Text>
                            <Typography.Text>{Utils.getDatetimeItFormatFromTimestamp(item.insertDate * 1000)}</Typography.Text></Flex>}
                        description={<div style={{ whiteSpace: 'pre-line' }} dangerouslySetInnerHTML={{ __html: sanitizeNoteHtml(item.text) }} />}
                    />
                </List.Item>
            )}
        />
    </div>
}